import React from 'react'
import { Link as RouterLink, useLoaderData,createBrowserRouter, createRoutesFromElements, Navigate, Await, BrowserRouter, Route, Routes, NavLink, useNavigate, useLocation, useOutlet} from 'react-router-dom'
const taiwlind_config_code= `/** @type {import('tailwindcss').Config} */
            module.exports = {
            content: ['./src/**/*.{js,jsx,ts,tsx}'],
            theme: {
               extend: {},
            },
            plugins: [],
            }`
const tailwind_test_code = `<div className='bg-red-300'>test</div>`
export default function ReactPage1(){
     return(
         <div className='text-left ml-[4px] mr-[4px] sm:m-auto sm:mt-8 w-auto md:w-[580px] lg:w-[780px]'>
         <h2 className='mb-4 text-lg structure__main__subttl'>React Cookbook</h2>
         <p className='text-sm mb-4'>Listed functions only requires frontend with React.<br/>
         When function needs to remain data even refleshed the page, data will be stored at localstorage or cache*.</p>
         <p className='text-xs leading-1  max-w-[540px]'>* If it cache and you are open the site from chrome, your data will be only see from the chrome and data will be gone when cache is cleared. 
         Chrome setting > Delete browing data or cache clean.</p>
         <br/>
         <h3 className='mt-4 text-lg font-bold mb-2'>Quick Start</h3>
         <div className='mb-8 text-xs'>
            1. Download zip folder. Open VS code and right click left side of item  to open terminal with right directory.<br/><br/>
            2. Install node-modules and packages<br/>
            <pre className='primary-code-container'>
            npm i
            </pre><br/>
            3. Click right side of scss > style.scss to open terminal with right directory and generate css code.<br/>
            <pre className='primary-code-container'>
            sass --watch style.scss style.css       
            </pre><br/>
            4. Run<br/>
            <pre className='primary-code-container'>
            npm run start
            </pre> 
         </div>
         <hr/>
         <h3 className='mt-4 text-lg font-bold mb-2'>Create environment from scratch (Optional)</h3>
         <h4 className='mt-8 text-xs'><b>1. Install vs code and node</b></h4><br/>
         <p className='text-xs mb-12'>
         If <RouterLink className='underline' to='https://code.visualstudio.com'>VS Code</RouterLink> is not installed on your pc, install it manually.<br/>
        <br/>
         Open vs code > terminal and run this command to check version.    
         <pre className='primary-code-container'>
            node -v<br/>
         </pre><br/>
         If <RouterLink className='underline' to='https://nodejs.org/en'>Node</RouterLink> is not installed on your pc, install it manually.<br/>
         </p>
         <p className='text-xs mb-12'>
         <h4 className='mt-2 text-xs'><b>2. Install React Template</b></h4><br/>
         <pre className='primary-code-container'>
            npx create-react-app@latest [your project name]<br/>
            cd [your project name]<br/>
            npm run start
         </pre>
         <b className='text-[8px]'>Resource: </b><RouterLink className='text-[8px]' to='https://create-react-app.dev/docs/getting-started/'>https://create-react-app.dev/docs/getting-started/</RouterLink><br/>
         </p>
         <p className='text-xs mb-12'>
         <h4 className='mt-2 mb-1 text-xs'><b>3. Install tailwind and other basic npm packages</b></h4><br/>
          <pre className='primary-code-container mb-4'>
            npm i axios dotenv react-icons
         </pre>
         <pre className='primary-code-container'>
            npm i tailwindcss@3.4.16 postcss@8.4.49 --save-dev 
         </pre><b className='text-[8px]'>Resource: </b><RouterLink className='text-[8px]' to='https://tailwindcss.com/docs/installation'>https://tailwindcss.com/docs/installation</RouterLink><br/><br/>
         
         Crete tailwind.config.js at same as package.json folder level and paste this.
         <pre className='primary-code-container'>
            {taiwlind_config_code}
         </pre>
         <br/>
         Create scss/stye.scss in src folder and add this.
         <pre className='primary-code-container'>
            @tailwind base;<br/>
            @tailwind components;<br/>
            @tailwind utilities;<br/>
         </pre>
         <br/>
         Add import to indexj.js or App.js file.
         <pre className='primary-code-container'>
            import './scss/style.css'
         </pre>
         <br/>
         Run this code to generate css file.
         <pre className='primary-code-container'>
            sass --watch style.scss style.css
         </pre>
         <br/>
         Check tailwind is working.
         <pre className='primary-code-container mb-4'>
            {tailwind_test_code}
         </pre>
         
         </p>
         <p className='text-xs mb-12'>
         <b>4. Select js or ts or ts-structured and paste purchased codes into created new file at src folder.</b><br/>
         You can try from <RouterLink className='underline' to='/react/basic'>trial codes</RouterLink> and see if it's works.
         </p>
         <p className='text-xs mb-12'>
         <b>5. Once you checked compoenent is working, study how it  works and arange it to your version.</b><br/>
         Check code of conduct to see professinal developer rules.<br/><RouterLink className='text-[8px] underline' to='../terms-and-conditions'>Terms & Conditions</RouterLink>
         </p>
         </div>
     )
}